<!-- 消息设置 -->
<template>
  <div class="out_wrap">
    <zf-table
      :columns="[{ prop: 'type_name', label: '通知类型'}, { prop: 'relation', label: '关联角色', width: '180'}]"
      :data-source="tableData"
      :pagination="false"
      style="width:700px;"
    >
      <!-- 关联角色 -->
      <template
        slot="relation"
        slot-scope="{ row }"
      >
        <a class="edit" @click="relation(row)">关联</a>
      </template>
    </zf-table>
    <!-- 公司配置 -->
    <MessageRoleConfig v-model="checkes" :visible.sync="dialogVisible" @submitFn="submitFn" />
  </div>
</template>

<script>
import ZfTable from '@/components/ZfTable/CoreTable'
import MessageRoleConfig from './components/MessageRoleConfig'
import { noticesetList, setNoticerole } from '@/api/set'
export default {
  components: {
    ZfTable,
    MessageRoleConfig
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      checkes: [],
      type_id: ''
    }
  },
  mounted() {
    this.getQuery()
  },
  methods: {
    async getQuery() {
      const res = await noticesetList()
      if (res.code === 200) {
        this.tableData = res.data
      }
    },
    relation(row) {
      console.log(row.role_ids, 'role_ids')
      if (row.role_ids) {
        if (row.role_ids !== -1) {
          this.checkes = row.role_ids.split(',')
        } else {
          this.checkes = row.role_ids
        }
      } else {
        this.checkes = []
      }
      this.type_id = row.type_id
      this.dialogVisible = true
    },
    async submitFn(checkes) {
      const res = await setNoticerole({
        type_id: this.type_id,
        role_ids: checkes
      })
      if (res.code === 200) {
        this.$message({ type: 'success', message: '设置成功' })
        this.getQuery()
        this.dialogVisible = false
      }
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
